/**
 * @file tourCard.component.tsx
 * @path apps/website/src/features/services/components/tourCard.component.tsx
 * @description Tour card utilizing the Sir Bastians design system.
 */

import { cn } from "@sirbastians/utils";
import { Service } from "@sirbastians/types";

interface TourCardProps {
  service: Service;
}

export const TourCard = ({ service }: TourCardProps) => {
  return (
    <div className="group relative w-full h-full overflow-hidden rounded-lg border border-border shadow-sm transition-all duration-500 hover:shadow-xl">
      {/* Image with zoom effect */}
      <img
        src={service.gallery.primary}
        alt={service.title}
        className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
      />

      {/* Gradient Overlay: 
          Uses your theme's primary color (HSL) for a branded shadow effect 
      */}
      <div
        className={cn(
          "absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent transition-opacity duration-500 z-0",
          "opacity-60 group-hover:opacity-80",
        )}
      />

      {/* Content Area */}
      <div
        className={cn(
          "absolute bottom-0 left-0 right-0 p-4 md:p-6 z-10",
          "text-primary-foreground transition-all duration-500",
        )}
      >
        <div className="flex justify-between items-end gap-2">
          <h3
            className={cn(
              "font-montserrat font-bold text-base md:text-xl line-clamp-2 transition-colors duration-300",
              "group-hover:text-accent", // Highlights in your Green-500 accent on hover
            )}
          >
            {service.title}
          </h3>

          {/* Subtle decorative element using your accent color */}
          <div className="w-8 h-[2px] bg-accent scale-x-0 transition-transform duration-500 origin-left group-hover:scale-x-100 mb-2" />
        </div>
      </div>
    </div>
  );
};
